import { createSelector, createFeatureSelector } from '@ngrx/store';
import { StoreSelector } from '../store-selector.const';
import { LogoState } from './logo.reducers';

export const selectlogoState = createFeatureSelector<LogoState>(StoreSelector.Logo);

export const selectLogo = {
  logo: createSelector(selectlogoState, (state: LogoState) => state.logo)
};
